import React from 'react'
import { Card, CardBody } from 'reactstrap'
import convertToAnswerLetters from '../../../helpers/assessment/convertToAnswerLetters';

/*
  <ItemPassage
    passage={props.activeItem ? props.activeItem.passage : ''}
    sectionBreaks={sectionBreaks}
    subtestId={props.subtestId}
    uAid={uAid}
  />
*/
export default class ItemPassage extends React.Component {

  state = { itemPos: 0 }

  componentDidMount(){
    let itemPos = this.calculateItemPosition();
    this.setState({ itemPos });
  }

  componentDidUpdate(prevProps) {
    
    if (prevProps.itemNumber !== this.props.itemNumber && this.props.itemChange) {
      let itemPos = this.calculateItemPosition();
      this.setState({ itemPos });
      (itemPos !== this.state.itemPos) &&
       ( navigator.appVersion.indexOf('Edge') > -1 || /^((?!chrome|android).)*safari/i.test(navigator.userAgent) ?
        document.querySelector('.passage').scrollTop = 0 : document.querySelector('.passage').scrollTo({ top: 0, behavior: 'smooth' }));
      let highlighted = document.querySelector('.hl');
      let highlightedUnderlined = document.querySelector('.hl-u');
      highlighted && ( /^((?!chrome|android).)*safari/i.test(navigator.userAgent) ? document.querySelector('.passage').scroll(0,highlighted.parentElement.offsetTop) : highlighted.parentElement.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' }));
      highlightedUnderlined && ( /^((?!chrome|android).)*safari/i.test(navigator.userAgent) ? document.querySelector('.passage').scroll(0,highlightedUnderlined.parentElement.offsetTop)  : highlightedUnderlined.parentElement.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' }));
    }
    
  }

  calculateItemPosition(){
    let closest = this.props.sectionBreaks.reduce((prev, curr) => Math.abs(curr - this.props.itemNumber) < Math.abs(prev - this.props.itemNumber) ? curr : prev);
    let itemPos = this.props.sectionBreaks.indexOf(closest);
    parseInt(closest) > parseInt(this.props.itemNumber) && itemPos > 0 && (itemPos = itemPos - 1)
    return itemPos;
  }


  render() {
    const { fontValue, passage } = this.props;
    return (
      <Card className='passage'>
        <CardBody>
          <div style={{ "fontSize": fontValue }} dangerouslySetInnerHTML={{ __html: passage }} />
        </CardBody>
      </Card>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessTest/ItemPassage.js